class AIService {
  constructor() {
    this.serverUrl = 'http://localhost:3001';
    this.apiUrl = '/api/generate-content';
    this.useRealAI = false; // Temporarily disable real AI
    this.hfApiKey = ''; // You'll need to get a valid key from huggingface.co/settings/tokens
    this.hfModel = 'facebook/bart-large-cnn';
  }

  async generateContent(title, description) {
    try {
      console.log(`Генерация контента для: ${title}`);
      let text = `${title}. ${description}`;

      if (this.useRealAI) {
        // Only attempt API call if useRealAI is true
        try {
          text = await this.paraphraseWithBART(text);
        } catch (error) {
          console.warn('Ошибка API, используем оригинальный текст:', error.message);
          // Continue with original text if API fails
        }
      } else {
        // Simple offline text processing when not using real AI
        console.log('Используется локальная обработка текста (без API)');
        // You could implement basic text transformation here if needed
      }

      return text;
    } catch (error) {
      console.error('Ошибка при генерации контента:', error);
      return 'Не удалось сгенерировать контент.';
    }
  }

  async paraphraseWithBART(text) {
    try {
      const url = `https://api-inference.huggingface.co/models/${this.hfModel}`;
      
      console.log('Отправка запроса в Hugging Face API');
      
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${this.hfApiKey}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          inputs: text,
          parameters: {
            max_length: Math.min(text.length + 20, 512),
            do_sample: true
          }
        })
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Hugging Face API response status:', response.status);
        console.error('Hugging Face API error details:', errorText);
        return text; // Return original text on error
      }

      const data = await response.json();
      return data[0]?.summary_text || text;
    } catch (error) {
      console.error('Ошибка при уникализации текста через BART:', error);
      return text; // Return original text on error
    }
  }
}

export default new AIService();